import { Button, Dialog, DialogContent, DialogFooter, Input, Markdown } from '@pm/ui';
import { type ReactNode, useState } from 'react';

/**
 * Confirmação. Com `confirmText` exige digitar o texto (RULE-044: hard delete pede palavra ou nome do registro).
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirmar',
  confirmText,
  danger,
  loading,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  confirmText?: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
}) {
  const [typed, setTyped] = useState('');
  const ok =
    !confirmText ||
    typed.trim().toLowerCase() === confirmText.trim().toLowerCase() ||
    typed.trim().toUpperCase() === 'EXCLUIR';

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) setTyped('');
        onOpenChange(o);
      }}
    >
      <DialogContent title={title} size="sm">
        {typeof description === 'string' ? <Markdown>{description}</Markdown> : description}
        {confirmText ? (
          <div className="mt-4 flex flex-col gap-1.5">
            <p className="text-sm text-text-2">
              Digite <span className="font-mono text-text-1">{confirmText}</span> (ou{' '}
              <span className="font-mono text-text-1">EXCLUIR</span>) para confirmar.
            </p>
            <Input
              mono
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              placeholder="Nome do registro"
              autoFocus
            />
          </div>
        ) : null}
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            disabled={!ok}
            loading={loading}
            onClick={onConfirm}
            className={danger && ok ? 'bg-danger text-text-inverse hover:bg-danger' : undefined}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
